import { all, call, getContext, put, takeLatest } from "redux-saga/effects";

import { getPostDetailsActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { normalizePost } from "@helpers/posts";
import { setAuthors } from "../authors/actions";
import { getPostDetailsFailure, getPostDetailsSuccess } from "./actions";
import { updateSubscriptions } from "../subscriptions/actions";

const getPostDetailsAsync = ({ PostsService, uniqueKey }) => {
  if (!PostsService) {
    return;
  }

  return PostsService.getPostByUniqueKey(uniqueKey);
};

function* getPostDetails({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    const { uniqueKey } = payload;
    const { data } = yield call(getPostDetailsAsync, {
      PostsService,
      uniqueKey,
    });

    const { result, entities } = normalizePost(data);
    const { authors, subscriptions, posts } = entities;
    const post = posts[result];
    yield all([
      put(setAuthors(authors)),
      put(updateSubscriptions({ subscriptions })),
      put(getPostDetailsSuccess(post)),
    ]);
  } catch ({ error }) {
    yield put(getPostDetailsFailure(error));
  }
}

export function* watchGetPostDetails() {
  yield takeLatest(getPostDetailsActionTypes.request, getPostDetails);
}
